import React from "react";
import Modal from "../Modal/Modal";
import HubspotForm from "react-hubspot-form";

class AcademyGate extends React.Component {
    state = {
        open: false,
        hubspotEmail: "",
    };

    checkGatedAccess = () => {
        let email = this.getCookieValue("academysubscriberemail");
        if(email) {
            this.setState({
                hubspotEmail: email
            });
            window.open("/lab-manager-academy/trial");
        } else {
            if(this.state.open) {
                this.closeModal();
            } else {
                this.openModal();
            }
        }
    }

    closeModal = () => {
        this.setState({
            open: false,
            error: ""
        });
    }

    openModal = () => {
        this.setState({
            open: true,
            error: ""
        });
    }

    componentDidMount() {
        let hubspotEmail = this.getCookieValue("academysubscriberemail");

        this.setState({
            hubspotEmail
        });
    }

    getCookieValue = (name) => {
        let cookie = document.cookie;
        let cookies = cookie.replace(/\s/g, "").split(";");
        let value = "";

        for(let i = 0; i<cookies.length; i++) {
            if(cookies[i].indexOf(`${name}=`) != -1) {
                value = cookies[i].replace(`${name}=`, "");
            }
        }

        return value;
    }

    setCookie = (cname, cvalue, exdays) => {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    onSubmit = (fields) => {
        if(fields.length && fields.length > 1) {
        // uncomment these lines to make trial page work

            // fields.pop(); 
            // let email = "";

            // for(let i = 0; i<fields.length; i++) {
            //     if(fields[i].name == "email") {
            //         email = fields[i].value;
            //         break;
            //     }
            // }

            // window.open("/lab-manager-academy/trial");

            // this.setCookie("academysubscriberemail", email, 395);
            // this.setState({
            //     hubspotEmail: email
            // });

        } else {
            console.error("hubspot error");
        }
    }

    render() {
        return (
          <div>
            {this.state.open && (
              <Modal>
                <div className="academy-gate-modal">
                  <div className="academy-gate-content">
                    <div className="close-btn" onClick={this.closeModal}>
                      X
                    </div>
                    <HubspotForm
                      portalId="547446"
                      formId="3061a091-7246-444c-a858-28f79b96b2a0"
                      onSubmit={this.onSubmit}
                    />
                    {this.state.error && (
                      <div className="invalid-feedback">{this.state.error}</div>
                    )}
                  </div>
                </div>
              </Modal>
            )}
            <button
              className="btn btn-academy-cta_v2"
              onClick={this.checkGatedAccess}
            >
              Sign up to be Notified
            </button>
          </div>
        );
    }
}

export default AcademyGate;